export const isStringArray = (value: any): value is string[] => {
    return Array.isArray(value);
};
